import { get, post, del } from "common/request"

export const dipRequest = {
  listAccounts: params => get(`/api/dip/account/all?${params}`),
  history: () => get(`/api/dip/account/history`),
  register: data => post("/api/dip/account/register", data),
  delAccount: (id, data) => del(`/api/dip/account/${id}`, data),
  uploadCertificate: data =>
    post("/api/dip/account/certificate/upload", data, {
      doNotSetContentType: true,
    }),
  uploadPrivateKey: data =>
    post("/api/dip/account/private-key/upload", data, {
      doNotSetContentType: true,
    }),
    
  submitReport: (massReportId, data) =>
    post(`/api/dip/massReport/${massReportId}/submit-report-known`, data),
  submitReportMS: (massReportId) =>
    post(`/api/dip/massReport/${massReportId}/submit-report-ms`),
  submitReportUnknown: (massReportId, data) =>
    post(`/api/dip/massReport/${massReportId}/submit-report-unknown`, data),

  updateStatus: (massReportId, data) =>
    post(`/api/dip/massReport/${massReportId}/update-status-known`, data),
  updateStatusMS: (massReportId) =>
    post(`/api/dip/massReport/${massReportId}/update-status-ms`),
  updateStatusUnknown: (massReportId, data) =>
    post(`/api/dip/massReport/${massReportId}/update-status-unknown`, data),


  currentTenant: () => get(`/api/dip/currentTenant`),


  delProtocols: (id, downloadProtocols = false, data) =>
    del(
      `/api/elmaas/account/${id}/protocols?downloadProtocols=${downloadProtocols}`,
      data,
    ),
}
